import { observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import BaseStore from '@src/utils/store/base-store';
import { aLink } from '@src/utils/common-util';
// import { $$tracker } from '@src/tracker';

class SecondSectionStore extends BaseStore {
  constructor(props = {}) {
    super();
    Object.assign(this, { ...props });
  }

  // 页面是否展示
  @observable isActive = false;

  // 赛事
  @observable competition_url;

  openCompetitionUrl() {
    aLink(this.competition_url);
  }

  // clickGame = () => {
  //   if (this.twitchDropLink) {
  //     aLink(this.twitchDropLink);
  //   }

  //   $$tracker.clickTD();
  // };

  use() {
    super.use();

    useMount(() => { });
  }
}

export default SecondSectionStore;
